import React, { useState } from "react";
import {
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { GameModes } from "../data/gameModes";

const MenuScreen = ({ startGame, showListing, showSettings }) => {
  const [selectedCategory, setSelectedCategory] = useState("all");

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const handleStartGame = (mode) => {
    startGame(mode, selectedCategory);
  };

  return (
    <Box id="menuScreen" className="screen active" sx={{ p: 2 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        英語學習小遊戲
      </Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="category-select-label">Category</InputLabel>
        <Select
          labelId="category-select-label"
          id="category-select"
          value={selectedCategory}
          label="Category"
          onChange={handleCategoryChange}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="normal">Normal</MenuItem>
          <MenuItem value="exam">Exam</MenuItem>
        </Select>
      </FormControl>
      <Box className="menu-options" sx={{ "& > button": { m: 1 } }}>
        <Button
          variant="contained"
          onClick={() => handleStartGame("ENGLISH_TO_CHINESE")}
        >
          英譯中
        </Button>
        <Button
          variant="contained"
          onClick={() => handleStartGame("CHINESE_TO_ENGLISH")}
        >
          中譯英
        </Button>
        <Button
          variant="contained"
          onClick={() => handleStartGame("PICTURE_TO_WORD")}
        >
          看圖識字
        </Button>
        <Button
          variant="contained"
          onClick={() => handleStartGame("LISTEN_ENGLISH_WORD")}
        >
          聽音辨字 (英)
        </Button>
        <Button
          variant="contained"
          onClick={() => handleStartGame("LISTEN_CHINESE_WORD")}
        >
          聽音辨字 (中)
        </Button>
        <Button
          variant="contained"
          onClick={() => handleStartGame("TIME_CHALLENGE")}
        >
          限時挑戰
        </Button>
        <Button variant="outlined" onClick={showListing}>
          生字列表
        </Button>
        <Button variant="outlined" onClick={showSettings}>
          設定
        </Button>
      </Box>
    </Box>
  );
};

export default MenuScreen;
